const cardStyle = {
  card: {
    border: '1px solid #E2E8EB',
    marginBottom: '24px',
    marginTop: '16px',
    borderRadius: '12px',
    color: '#1F2A32',
    background: '#fff',
    width: '100%',
    boxShadow: '0 1px 2px rgba(31, 42, 50, 0.04), 0 8px 24px rgba(31, 42, 50, 0.06)',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    minWidth: '0',
    wordWrap: 'break-word',
    fontSize: '.875rem',
    overflow: 'hidden',
  },
  cardPlain: {
    background: 'transparent',
    boxShadow: 'none',
    border: 'none',
  },
  cardProfile: {
    marginTop: '30px',
    textAlign: 'center',
  },
  cardChart: {
    '& p': {
      marginTop: '0px',
      paddingTop: '0px',
    },
  },
};

export default cardStyle;
